export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["要使用您账户的所有功能，请完成快速身份验证。这有助于我们保障您的账户安全并遵守金融法规。"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["立即验证"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["稍后"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["验证您的身份"])}
}